import { createSelector, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { PaginationModel } from "../../OrganizationManager/model/organization";
import { Address, ConfirmDialog } from "../model/address";
import { fetchAddressesInContact, fetchAddressesInOrganization, updateAddress } from "./asyncThunks";

export const initialAddressState = {
    data: [] as Address[],
    pagination: {
        startRow: 0,
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 20, 50, 100],
        totalRowCount: 0,
    } as PaginationModel,
    confirmDialog: {
        open: false,
        title: "Delete",
        message: "",
    } as ConfirmDialog,
};

export const addressListSlice = createSlice({
    name: "addressList",
    initialState: initialAddressState,
    reducers: {
        onChangeAddressPage: (state, action): void => {
            state.pagination.startRow = action.payload;
        },
        onChangeAddressRowPerPage: (state, action): void => {
            state.pagination.rowsPerPage = action.payload;
        },
        onChangeConfirmDialog: (state, action): void => {
            state.confirmDialog = action.payload;
        },
    },
    extraReducers: {
        [`${fetchAddressesInContact.fulfilled}`]: (state, action): void => {
            state.data = action.payload;
            state.pagination.startRow = 0;
            state.pagination.totalRowCount = state.data.length;
        },
        [`${fetchAddressesInOrganization.fulfilled}`]: (state, action): void => {
            state.data = action.payload;
            state.pagination.startRow = 0;
            state.pagination.totalRowCount = state.data.length;
        },
        [`${updateAddress.fulfilled}`]: (state, action): void => {
            state.data = action.payload;
            state.pagination.startRow = 0;
            state.pagination.totalRowCount = state.data.length;
        },
    },
});

// Actions
export const { onChangeAddressPage, onChangeAddressRowPerPage, onChangeConfirmDialog } = addressListSlice.actions;

// Selectors
export const addressesSelector = createSelector(
    (state: RootState): Address[] => state.addressList.data,
    (data: Address[]): Address[] => data
);

export const paginationSelector = createSelector(
    (state: RootState): PaginationModel => state.addressList.pagination,
    (pagination: PaginationModel): PaginationModel => pagination
);

export const confirmDialogSelector = createSelector(
    (state: RootState): ConfirmDialog => state.addressList.confirmDialog,
    (confirmDialog: ConfirmDialog): ConfirmDialog => confirmDialog
);
